import { LocaleService } from '../modules/shared/services/locale.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

    constructor(private localeService: LocaleService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const locale = this.localeService.activeLocale();
        if (locale && request.url.startsWith(environment.apiUrl)) {
            request = request.clone({
                setHeaders: {
                    'Accept-Language': locale
                }
            });
        }

        return next.handle(request);
    }
}